<template>
  <BasicAlert
    alertLabel="Les champs avec * sont obligatoires."
    class="form--mandatory"
  />
  <RechercheFormation />
  <ChoixTypeModule />
  <BasicRedirection
    :show-if="!!moduleEnCours"
    @after-scroll="définirModuleEnCours(null)"
  >
    <template #topAnchor>
      <ListeModules />
    </template>
    <template #bottomAnchor>
      <Module />
    </template>
  </BasicRedirection>
</template>

<script setup lang="ts">
  import Module from './sections/module/ModuleSection.vue'
  import ChoixTypeModule from './modal/ChoixTypeModule.vue'
  import ListeModules from './sections/list/ListeModulesSection.vue'
  import RechercheFormation from './sections/recherche/RechercheFormationSection.vue'
  import { inject } from 'vue'
  import { type ModuleAction, ModuleActionKey } from './useModuleActions'

  const { moduleEnCours, définirModuleEnCours } = inject<ModuleAction>(ModuleActionKey)!
</script>
